<template>
  <v-layout row wrap>
    <v-flex xs12 class="text-sm-center">
      <span class="headline">SETTINGS</span>
    </v-flex>

    <v-flex xs12 md6 pr-4>
      <v-flex xs12 pb-3>
        <span class="headline">Sponsorship Type</span>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="sponsorTypeHeader"
          :items="types"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.notes }}</td>
            <td class="text-xs-center">{{ props.item.order }}</td>
            <td class="text-xs-center">{{ props.item.active }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                @click="updateType(props.item)"
              >
                edit
              </v-icon>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 pt-3 class="justify-right layout px-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addType()">Add Type</v-btn>
      </v-flex>

      <v-flex xs12 pt-4>
        <span class="headline">Sponsor Levels</span><br />
        (Click level to show and edit the items)
      </v-flex>
      <v-flex xs12 pt-3>
        <v-data-table
          :headers="sponsorLevelHeader"
          :items="levels"
          :expand="expand"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
              <td class="text-xs-left">{{ props.item.DefaultSponsorType.name }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.notes }}</td>
              <td class="text-xs-center">${{ props.item.price }}</td>
              <td class="text-xs-center">{{ props.item.order }}</td>
              <td class="justify-center layout px-0">
                <v-icon
                  @click="updateLevel(props.item)"
                >
                  edit
                </v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-card flat>
              <v-card-text>
                <v-flex xs12>
                  <v-list>
                    <v-list-tile
                      v-for="item in props.item.sponsorItems"
                      :key="item.value"
                      dense
                      avatar
                    >
                      <v-list-tile-avatar></v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="blue" @click="itemLevel(props.item.id)">Add Item</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 pt-3 class="justify-right layout px-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addLevel()">Add Level</v-btn>
      </v-flex>

      <v-flex xs12 pt-4>
        <span class="headline">Email Templates</span>
      </v-flex>
      <v-flex xs12 pt-3>
        <v-data-table
          :headers="emailHeaders"
          :items="emails"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.subject }}</td>
            <td class="text-xs-center">{{ props.item.status }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                @click="updateEmail(props.item)"
              >
                edit
              </v-icon>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 pt-3 class="justify-right layout px-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addEmail()">Add Email Template</v-btn>
      </v-flex>
    </v-flex>

    <v-flex xs12 md6 pl-4>
      <v-flex xs12 pb-3>
        <span class="headline">Sponsor Items</span>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="sponsorItemHeader"
          :items="items"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.notes }}</td>
            <td class="text-xs-center">{{ props.item.quantity }}</td>
            <td class="text-xs-center">{{ props.item.order }}</td>
            <td class="text-xs-center">{{ props.item.active }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                @click="updateItem(props.item)"
              >
                edit
              </v-icon>
            </td>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex xs12 pt-3 class="justify-right layout px-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addItem()">Add Item</v-btn>
      </v-flex>

      <v-flex xs12 pt-4>
        <span class="headline">File Categories</span>
      </v-flex>
      <v-flex xs12 pt-3>
        <v-data-table
          :headers="fileHeaders"
          :items="files"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.subject }}</td>
            <td class="text-xs-center">{{ props.item.active }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                @click="updateFileCategory(props.item)"
              >
                edit
              </v-icon>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 pt-3 class="justify-right layout px-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addFileCategory()">Add File Category</v-btn>
      </v-flex>
    </v-flex>

    <v-dialog
      v-model="typeDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Sponsor Type</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  label="Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.notes"
                  label="Notes"
                  prepend-icon="notes"
                ></v-textarea>
              </v-flex>
              <v-flex xs6 md4>
                <v-select
                  v-model="editedItem.order"
                  :items="typeOrders"
                  label="Order"
                ></v-select>
              </v-flex>
              <v-flex xs6 md4>
                <v-select
                  v-model="editedItem.active"
                  :items="yesNo"
                  label="Active"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveType()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="itemDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Sponsor Item</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  label="Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.notes"
                  label="Notes"
                  prepend-icon="notes"
                ></v-textarea>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="editedItem.quantity"
                  label="Qty"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="editedItem.price"
                  @keyup.enter="save"
                  label="Amount"
                  prefix="$"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="editedItem.dueDate"
                  @keyup.enter="save"
                  label="Due Date"
                  mask="##/##/####"
                  return-masked-value
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="editedItem.order"
                  :items="itemOrders"
                  label="Order"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="editedItem.active"
                  :items="yesNo"
                  label="Active"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveItem()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="itemLevelDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Item to Level</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs6>
                <v-select
                  v-model="editedItem.itemId"
                  :items="sponsorItems"
                  item-text="name"
                  item-value="value"
                  label="Item"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="addItemLevel()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="levelDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Sponsor Level</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12 md6>
                <v-select
                  v-model="editedItem.DefaultSponsorTypeId"
                  :items="sponsorTypes"
                  item-text="name"
                  item-value="value"
                  label="Sponsor Type"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  label="Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.notes"
                  label="Notes"
                  prepend-icon="notes"
                ></v-textarea>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="editedItem.price"
                  @keyup.enter="save"
                  label="Amount"
                  prefix="$"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="editedItem.order"
                  :items="itemOrders"
                  label="Order"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="editedItem.active"
                  :items="yesNo"
                  label="Active"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-btn v-if="addItems" color="primary" @click="saveLevel()">Items</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveLevel()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="fileDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit File Category</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  label="Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="editedItem.active"
                  :items="yesNo"
                  label="Active"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveFileCategory()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="emailDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="1000px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Email</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-layout>
            <v-flex xs8>
              <v-container grid-list-md>
                <v-layout class="pb-3" wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.name"
                      @keyup.enter="save"
                      label="Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.subject"
                      @keyup.enter="save"
                      label="Subject"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4>
                    <v-select
                      v-model="editedItem.status"
                      :items="status"
                      label="Status"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <wysiwyg v-model="editedItem.text" />
                  </v-flex>
                  <v-flex xs12 class="justify-right layout px-0">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveEmail()">Save</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex xs3>
              Company - <b>%company%</b><br />
              Password - <b>%password%</b><br />
              Contact First Name - <b>%firstname%</b><br />
              Contact Last Name - <b>%lastname%</b><br />
              Payment Type - <b>%ptype%</b><br />
              Payment Amount - <b>%pamount%</b>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'

export default {
  props: ['visible'],

  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'settings',
      loading: false,
      expand: false,
      locations: [
        {value: 'All', name: 'All'},
        {value: 'Vendor Alley', name: 'Vendor Alley'},
        {value: 'Food Court', name: 'Food Court'},
        {value: 'Grounds', name: 'Grounds'}
      ],
      yesNo: ['Yes', 'No'],
      per: ['sqft', 'ea'],
      status: ['active', 'inactive'],
      sponsorTypeHeader: [
        {text: 'Type', align: 'left', sortable: false, value: 'name'},
        {text: 'Notes', align: 'left', sortable: false, value: 'notes'},
        {text: 'Order', align: 'center', sortable: false, value: 'order'},
        {text: 'Active', align: 'center', sortable: false, value: 'active'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      sponsorTypes: [],
      types: [],
      typeDialog: false,
      typeOrders: [],
      sponsorItemHeader: [
        {text: 'Item', align: 'left', sortable: false, value: 'name'},
        {text: 'Notes', align: 'left', sortable: false, value: 'notes'},
        {text: 'Qty', align: 'center', sortable: false, value: 'quantity'},
        {text: 'Order', align: 'center', sortable: false, value: 'order'},
        {text: 'Active', align: 'center', sortable: false, value: 'active'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      sponsorItems: [],
      items: [],
      itemDialog: false,
      itemLevelDialog: false,
      itemOrders: [],
      sponsorLevelHeader: [
        {text: 'Type', align: 'left', sortable: false, value: 'name'},
        {text: 'Level', align: 'left', sortable: false, value: 'name'},
        {text: 'Notes', align: 'left', sortable: false, value: 'notes'},
        {text: 'Price', align: 'center', sortable: false, value: 'price'},
        {text: 'Order', align: 'center', sortable: false, value: 'order'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      levels: [],
      levelDialog: false,
      levelOrders: [],
      addItems: false,
      fileHeaders: [
        {text: 'name', align: 'center', sortable: false, value: 'name'},
        {text: 'Active', align: 'center', sortable: false, value: 'active'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      files: [],
      fileDialog: false,
      emails: [],
      emailHeaders: [
        {text: 'Name', align: 'left', sortable: false, value: 'name'},
        {text: 'Subject', align: 'left', sortable: false, value: 'subject'},
        {text: 'Status', align: 'center', sortable: false, value: 'status'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      emailDialog: false,
      editedItem: {},
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getTypes()
    this.getItems()
    this.getLevels()
    this.getFileCategories()
    this.getEmails()

    this.loading = false
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 360
      this.height = height + 'px'
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    async getTypes () {
      try {
        const response = await Api().get('sponsor_all_types/')

        let sponsorType = {}

        if (response.data.length === 0) {
          this.typeOrders.push(1)
        } else {
          for (let i in response.data) {
            let j = Number(i) + 1
            this.typeOrders.push(j)
            sponsorType.value = response.data[i].id
            sponsorType.name = response.data[i].name
            this.sponsorTypes.push(sponsorType)
            sponsorType = {}
          }

          let k = response.data.length + 1
          this.typeOrders.push(k)
        }

        this.types = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addType () {
      this.typeDialog = true
    },

    updateType (item) {
      this.editedItem = item
      this.typeDialog = true
    },

    async saveType () {
      try {
        let response
        if (this.editedItem.id > 0) {
          response = await Api().put('sponsor_types/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('sponsor_types/', this.editedItem)
        }

        this.getTypes()
        this.editedItem = {}
        this.typeDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getItems () {
      try {
        const response = await Api().get('sponsor_all_items/')

        let sponsorItem = {}

        if (response.data.length === 0) {
          this.itemOrders.push(1)
        } else {
          for (let i in response.data) {
            let j = Number(i) + 1
            this.itemOrders.push(j)
            sponsorItem.value = response.data[i].id
            sponsorItem.name = response.data[i].name

            if (response.data[i].dueDate) {
              const [year, month, day] = response.data[i].dueDate.split('-')
              response.data[i].dueDate = `${month}/${day}/${year}`
            }
            // sponsorItem.dueDate = this.formatDate(sponsorItem.dueDate)

            if (response.data[i].quantity > 0) {
              sponsorItem.name = sponsorItem.name + ' - Qty = ' + response.data[i].quantity
            }

            if (response.data[i].price > 0) {
              sponsorItem.name = sponsorItem.name + ' - @ $' + response.data[i].price
            }

            this.sponsorItems.push(sponsorItem)
            sponsorItem = {}
          }

          let k = response.data.length + 1
          this.itemOrders.push(k)
        }

        this.items = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addItem () {
      this.itemDialog = true
    },

    itemLevel (levelId) {
      this.editedItem.levelId = levelId
      this.itemLevelDialog = true
    },

    updateItem (item) {
      this.editedItem = item
      this.itemDialog = true
    },

    async addItemLevel () {
      try {
        let response = await Api().post('sponsor_itemLevel/', this.editedItem)

        this.getLevels()
        this.editedItem = {}
        this.itemLevelDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveItem () {
      try {
        if (this.editedItem.dueDate) {
          const [month, day, year] = this.editedItem.dueDate.split('/')
          this.editedItem.dueDate = `${year}-${month}-${day}`
        } else {
          this.editedItem.dueDate = null
        }

        let response
        if (this.editedItem.id > 0) {
          response = await Api().put('sponsor_items/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('sponsor_items/', this.editedItem)
        }

        this.getItems()
        this.editedItem = {}
        this.itemDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getLevels () {
      try {
        const response = await Api().get('sponsor_all_levels/')
        console.log(response.data)

        if (response.data.length === 0) {
          this.levelOrders.push(1)
        } else {
          for (let i in response.data) {
            let j = Number(i) + 1
            this.levelOrders.push(j)

            let sponsorItem = {}
            let sponsorItems = []

            for (let j in response.data[i].DefaultSponsorItems) {
              sponsorItem.value = response.data[i].DefaultSponsorItems[j].id
              sponsorItem.name = response.data[i].DefaultSponsorItems[j].name

              if (response.data[i].DefaultSponsorItems[j].quantity > 0) {
                sponsorItem.name = sponsorItem.name + ' - Qty = ' + response.data[i].DefaultSponsorItems[j].quantity
              }

              if (response.data[i].DefaultSponsorItems[j].price > 0) {
                sponsorItem.name = sponsorItem.name + ' - @ $' + response.data[i].DefaultSponsorItems[j].price
              }

              sponsorItems.push(sponsorItem)
              response.data[i].sponsorItems = sponsorItems
              sponsorItem = {}
            }
          }

          let k = response.data.length + 1
          this.levelOrders.push(k)
        }

        this.levels = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addLevel () {
      this.addItems = false
      this.levelDialog = true
    },

    updateLevel (item) {
      this.editedItem = item
      this.addItems = true
      this.levelDialog = true
    },

    async saveLevel () {
      try {
        let response
        if (this.editedItem.id > 0) {
          response = await Api().put('sponsor_levels/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('sponsor_levels/', this.editedItem)
        }

        this.getLevels()
        this.editedItem = {}
        this.levelDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getFileCategories () {
      try {
        const response = await Api().get('file_categories/Sponsor')
        this.files = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addFileCategory () {
      this.fileDialog = true
    },

    updateFileCategory (item) {
      this.editedItem = item
      this.fileDialog = true
    },

    async saveFileCategory () {
      this.editedItem.section = 'Sponsor'
      this.editedItem.UserId = this.myId

      try {
        let response
        if (this.editedItem.id > 0) {
          response = await Api().put('file_categories/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('file_categories/', this.editedItem)

          this.files.push(response.data.file)
        }

        this.fileDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getEmails () {
      try {
        const response = await Api().get('get_email_templates/Sponsor')
        this.emails = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addEmail () {
      this.emailDialog = true
    },

    updateEmail (item) {
      this.editedItem = item
      this.emailDialog = true
    },

    async saveEmail () {
      this.editedItem.section = 'Sponsor'
      this.editedItem.UserId = this.myId

      try {
        let response
        if (this.editedItem.id > 0) {
          response = await Api().put('sponsor_email_templates/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('sponsor_email_templates/', this.editedItem)

          this.emails.push(response.data.email)
        }

        this.emailDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.typeDialog = false
      this.itemDialog = false
      this.itemLevelDialog = false
      this.levelDialog = false
      this.fileDialog = false
      this.emailDialog = false
      this.editedItem = {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/sponsor/Settings.vue